const NoRouteFound = () => {
    return (
        <div>no match any console route found</div>
    );
};
export default NoRouteFound;